import sc, { css } from 'styled-components';
import { Media } from '../../../../../theme/Media';
import { SUBSECTION_DATA_ATTR } from '../../constants';
export const SubSectionWrapper = sc.div.attrs({
    [SUBSECTION_DATA_ATTR]: true,
}) `
  display: flex;
  flex-direction: column;

  ${({ height }) => height &&
    css `
      height: ${height};
    `}
`;
export const TitleWrapper = sc.div `
  margin: 0;
  padding: 19px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ onClick }) => !!onClick && 'pointer'};

  & span {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  @media ${Media.xsMax} {
    padding: 16px 12px;
  }
`;
export const Title = sc.span `
  ${({ theme }) => theme.typography.titleSub};
  padding: 5px 0px;
`;
export const SubTitle = sc.div `
  padding: 4px 24px;

  @media ${Media.xsMax} {
    padding: 4px 16px;
  }
`;
export const ActionsWrapper = sc.div `
  display: flex;
  gap: 8px;
`;
export const CollapsibleWrapper = sc.div `
  position: relative;
  flex: ${({ hasFixedHeight }) => (hasFixedHeight ? '1' : '0 1 auto')};
  min-height: 0;
  overflow: ${({ overflow }) => overflow};

  ${({ hasFixedHeight }) => hasFixedHeight &&
    css `
      display: flex;
      flex-direction: column;
    `}
`;
export const ContentWrapper = sc.div `
  padding: ${({ noPadding, withoutTitle }) => (noPadding ? 0 : withoutTitle ? '24px' : '0 24px 24px')};

  ${({ hasFixedHeight }) => hasFixedHeight &&
    css `
      flex: 1;
      min-height: 0;
    `}

  @media ${Media.xsMax} {
    padding: ${({ noPadding, withoutTitle }) => (noPadding ? 0 : withoutTitle ? '16px 12px' : '0 12px 16px')};
  }

  ${({ theme, horizontal, childCount }) => horizontal &&
    css `
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      /* Add right border to odd-numbered children (left column) */
      & > *:nth-child(odd) {
        border-right: 1px solid ${theme.colors.grey10_1};
      }

      /* Add bottom border to all items except those in the last row */
      ${childCount > 2 &&
        css `
        & > *:nth-child(-n + ${childCount - (childCount % 2 || 2)}) {
          border-bottom: 1px solid ${theme.colors.grey10_1};
        }
      `}
    `}

  ${({ customStyles }) => customStyles}
`;
